module.exports = __webpack_public_path__ + "static/media/jump.50853577.png";